import React from "react";
import { Button } from "../ui/button";
import { Sparkles, X } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * ChatHeader Component
 * Displays the chat header with title, status indicator, and optional close button
 */
const ChatHeader = ({
  isLoading,
  isAvailable,
  onClose,
  showCloseButton = false,
}) => {
  return (
    <div className="bg-gradient-to-br from-primary via-primary to-orange-600 text-white p-3 sm:p-4 flex items-center justify-between relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />

      <div className="flex items-center relative z-10">
        <div className="relative mr-3">
          <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 animate-pulse" />
          <div
            className={cn(
              "absolute -top-1 -right-1 w-2 h-2 rounded-full",
              isLoading
                ? "bg-yellow-400 animate-pulse"
                : isAvailable
                ? "bg-emerald-400"
                : "bg-red-400"
            )}
          />
        </div>
        <div>
          <h2 className="text-sm sm:text-lg font-bold leading-tight">
            Koflip AI Assistant
          </h2>
          <p className="text-[0.65rem] sm:text-xs text-start opacity-90 hidden sm:block font-medium">
            {isLoading
              ? "Initializing..."
              : isAvailable
              ? "Powered by ChatGPT"
              : "Temporarily Offline"}
          </p>
        </div>
      </div>

      {showCloseButton && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="text-white hover:bg-white/20 active:scale-95 h-8 w-8 relative z-10"
        >
          <X className="h-5 w-5" />
        </Button>
      )}
    </div>
  );
};

export default ChatHeader;
